import CompanyUser from "../../model2/company-user-new/company-user";
import {BUS_COMPANY_USERS_CHANGED} from "../../model2/company-user-new/@const";
import SessionEventProto from "../session-event-proto";


export default class EventCompanyUsersNew extends SessionEventProto {

    process() {
        if (this.isDifferentCompany()) return false;

        // make sure user itself in sessionusers (!) add if not
        let user = gd.session.users.get(this.data.userId);
        if (!user) {
            gd.session.users.add(this.data.user);
            user = gd.session.users.get(this.data.userId);
        }

        const newCompanyUserModel = new CompanyUser({
            userId          : this.data.userId,
            companyId       : this.data.companyId,
            companyRole     : this.data.companyRole,
            departmentId    : this.data.departmentId,
            reportToUserId  : this.data.reportToUserId,
            workWeek        : this.data.workWeek,
            workdayDurations: this.data.workdayDurations
        });

        gd.session.companyUsers.add(newCompanyUserModel);
        gd.bus.triggerEvent(BUS_COMPANY_USERS_CHANGED)
    }
};




// export default class EventCompanyUsersResetByCompany extends EventActionProto {
//
//     constructor(uid, data) {
//         super(uid, data);
//     }
//
//
//
//     process() {
//
//         // make sure user itself in sessionusers (!) add if not
//         let user = gd.session.users.get(this.data.userId);
//         if (!user) {
//             gd.session.users.add(this.data.user);
//             user = gd.session.users.get(this.data.userId);
//         }
//
//         const newCompanyUserModel = new CompanyUser({
//             userId: this.data.userId,
//             companyId: this.data.companyId,
//             companyRole: this.data.companyRole,
//             departmentId: this.data.departmentId,
//             reportToUserId: this.data.reportToUserId,
//             workWeek: this.data.workWeek,
//             workdayDurations: this.data.workdayDurations
//         });
//
//         gd.session.companyUsers.add(newCompanyUserModel);
//         gd.bus.triggerEvent(BUS_COMPANY_USERS_CHANGED)
//
//         super.process();
//     }
// };

